export const DOCS = {
  getting_started: 'https://docs.kindata.ru/profit/getting-started/',
  marketplace_ozon: 'https://docs.kindata.ru/profit/marketplace/ozon/',
  marketplace_wb: 'https://docs.kindata.ru/profit/marketplace/wildberries/',
  marketplace_yandex: 'https://docs.kindata.ru/profit/marketplace/yandex-market/',
  cost_management: 'https://docs.kindata.ru/profit/cost-management/',
  pricing: 'https://docs.kindata.ru/profit/pricing/',
  orders: 'https://docs.kindata.ru/profit/orders/',
  strategies: 'https://docs.kindata.ru/profit/strategies/',
  settings: 'https://docs.kindata.ru/profit/settings/',
  main: 'https://docs.kindata.ru/profit/'
}

export function getDocLink(key) {
  return DOCS[key] || ''
}
